(() => {
  'use strict';
  const key = 'ella-gift-checkout-v1';
  const configNode = document.getElementById('EllaGiftCheckoutConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  let gift;
  try {
    gift = JSON.parse(sessionStorage.getItem(key));
    if (!gift || gift.expires < Date.now() || !/^[a-z0-9]{8,20}$/i.test(gift.code)) {
      sessionStorage.removeItem(key);
      return;
    }
  } catch (_) { return; }
  let pending = false;
  const root = config.root.replace(/\/?$/, '/');
  let banner;
  function message(text, error = false) {
    if (!banner) {
      banner = document.createElement('aside');
      banner.setAttribute('aria-label', 'Dein Gutschein');
      banner.style.cssText = 'position:relative;z-index:5;background:#f2f7f0;color:#173b37;padding:16px 24px;border-bottom:1px solid #8aa38c;font:15px/1.6 Arial,sans-serif';
      const status = document.createElement('span');
      status.setAttribute('role', 'status');
      banner.append(status);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Automatische Übernahme ausschalten';
      remove.style.cssText = 'margin-left:16px;text-decoration:underline;background:transparent;border:0;color:inherit;cursor:pointer';
      remove.addEventListener('click', () => {
        if (pending) return;
        sessionStorage.removeItem(key);
        gift = null;
        banner.remove();
      });
      banner.append(remove);
      document.body.prepend(banner);
    }
    banner.firstElementChild.textContent = text;
    banner.style.background = error ? '#fff3df' : '#f2f7f0';
  }
  const manual = () => `Die automatische Übernahme ist hier nicht möglich. Gib den Gutscheincode ${gift.code} bitte im Checkout ein. Schalte dazu die automatische Übernahme aus und gehe erneut zur Kasse.`;
  message(config.b2b
    ? 'Gutschein vorgemerkt. Bei Firmenbestellungen gibst du den Code bitte im Checkout ein; deine Partnerpreise bleiben erhalten.'
    : 'Gutschein vorgemerkt. Beim Gang zur Kasse prüfen wir das Guthaben und übernehmen den Gutschein automatisch.');
  const query = 'mutation EllaGiftCheckout($input:CartInput!){cartCreate(input:$input){cart{id checkoutUrl totalQuantity cost{subtotalAmount{amount currencyCode}} discountCodes{code applicable} appliedGiftCards{lastCharacters amountUsed{amount currencyCode}} lines(first:250){nodes{quantity merchandise{... on ProductVariant{id}} attributes{key value}} pageInfo{hasNextPage}}} userErrors{field message} warnings{code message}}}';
  const pairs = object => Object.entries(object || {}).map(([key, value]) => ({key, value: String(value ?? '')}));
  function signature(lines) {
    return lines.map(line => JSON.stringify({
      id: line.merchandiseId || line.merchandise.id,
      quantity: line.quantity,
      attributes: [...(line.attributes || [])].sort((a,b) => a.key.localeCompare(b.key))
    })).sort().join('|');
  }
  async function checkout() {
    if (pending || !gift) return;
    pending = true;
    message('Dein Gutschein und dein Warenkorb werden geprüft …');
    try {
      const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      // Complex baskets stay in the original checkout instead of losing relationships or subscriptions.
      if (!cart.items?.length || cart.items.length > 250 || cart.items.some(item => item.gift_card || item.selling_plan_allocation || item.parent_relationship || item.item_components?.length)) throw new Error('unsupported');
      const lines = cart.items.map(item => ({merchandiseId:'gid://shopify/ProductVariant/' + item.variant_id, quantity:item.quantity, attributes:pairs(item.properties)}));
      const discountCodes = [...new Set((cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title))];
      const input = {lines, giftCardCodes:[gift.code], note:cart.note || '', attributes:pairs(cart.attributes), buyerIdentity:{countryCode:config.country}, discountCodes};
      const apiResponse = await fetch(config.endpoint, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables:{input}})});
      if (!apiResponse.ok) throw new Error('api');
      const result = await apiResponse.json();
      const payload = result.data?.cartCreate;
      const created = payload?.cart;
      if (result.errors?.length || payload?.userErrors?.length || payload?.warnings?.length || !created) throw new Error('validation');
      if (created.lines.pageInfo.hasNextPage || signature(lines) !== signature(created.lines.nodes)) throw new Error('lines');
      if (created.totalQuantity !== cart.item_count || created.cost.subtotalAmount.currencyCode !== cart.currency || Math.round(Number(created.cost.subtotalAmount.amount)*100) !== cart.items_subtotal_price) throw new Error('prices');
      if (discountCodes.some(code => !created.discountCodes.some(d => d.applicable && d.code.toLowerCase() === code.toLowerCase()))) throw new Error('discount');
      if (!created.appliedGiftCards.some(g => g.lastCharacters.toLowerCase() === gift.code.slice(-4).toLowerCase())) {
        message('Shopify konnte den Gutschein nicht übernehmen. Prüfe Code und Guthaben auf deiner Gutscheinseite. Du kannst die automatische Übernahme ausschalten und den Code im Checkout erneut eingeben.', true);
        return;
      }
      const target = new URL(created.checkoutUrl);
      if (target.protocol !== 'https:' || !(target.hostname === location.hostname || target.hostname === 'ellashaarshop.de' || target.hostname === 'ella-s-profi-shop.myshopify.com' || target.hostname === 'checkout.shopify.com')) throw new Error('url');
      message('Gutschein übernommen. Du wirst zum Checkout weitergeleitet …');
      location.assign(target.href);
    } catch (_) {
      message(manual(), true);
    } finally { pending = false; }
  }
  const isCheckout = node => {
    if (!(node instanceof Element)) return false;
    return node.closest('[name="checkout"],a[href="/checkout"],a[href="/checkout/"]');
  };
  document.addEventListener('click', event => {
    if (!gift || config.b2b || !isCheckout(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);
  document.addEventListener('submit', event => {
    if (!gift || config.b2b || !event.target.matches('form[action$="/cart"]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (!event.submitter) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);
})();
